import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import FormattersStore from '../stores/Formatters';

export default class PhoneNumberInput extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.formatPhoneNumber = this.formatPhoneNumber.bind(this);
  }

  formatPhoneNumber(numberAsString) {
    if (!numberAsString) return '';

    const { phoneNumberFormatter } = FormattersStore.getState();

    return phoneNumberFormatter.formatPhoneNumber(numberAsString);
  }

  render() {
    const { value, onChange } = this.props;
    const { formatPhoneNumber } = this;
    const { Input } = UX2.Element;

    return (
      <Input
        { ...this.props }
        type='tel'
        value={ value }
        onBlur={ e => onChange(formatPhoneNumber(e.target.value)) }
        onChange={ e => onChange(e.target.value) }
      />
    );
  }
}
